import { render, staticRenderFns } from "./CommonCheckbox.vue?vue&type=template&id=e4ffd68a&scoped=true"
import script from "./CommonCheckbox.vue?vue&type=script&lang=ts"
export * from "./CommonCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./CommonCheckbox.vue?vue&type=style&index=0&id=e4ffd68a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ffd68a",
  null
  
)

export default component.exports